import { FB_PIXEL_ACCESS } from '@/helpers/permissionsConstant'

export default [
  {
    title: 'Legacy Pixel Code',
    route: 'admin-fb-pixel',
    icon: 'BoxIcon',
    gate: FB_PIXEL_ACCESS,
  },
]